import React from 'react'
import { motion } from 'framer-motion'
import img from '../../Assets/img/Events/objective1.JPG'
import img2 from '../../Assets/img/Events/objective2.JPG'
import banner from '../../Assets/img/banner2.avif'
import { useNavigate } from 'react-router-dom'
import './about.css'
import PublicHeader from '../Header/PublicHeader'
import Footer from '../Footer'

const Objectives = () => {
  const navigate = useNavigate()

  const handleContact = () => {
    navigate('/membership')
  }
  return (
    <>
      <PublicHeader />

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className='about-us mx-auto'
      >
        {/* Section Header */}
        <div
          className="section-header md:mt-[40px] mt-0"       
        >
          <div className='header-content px-5'>
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              className='text-left'
            >
              <h1 className="display-4 fw-bold mb-2 text-white">APCCI Objectives</h1>
              
            </motion.div>
          </div>
          
        </div>
        {/* <h3 className="text-5xl font-bold text-gray-800 text-center my-12 ">Our Objectives</h3> */}
        {/* objectives */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8 }}
          className='grid1 container md:grid1-cols-2 gap-16 mt-4  '
        >
          {/* Text Content */}
          <div className="p-6  bg-white mb-10 lg:p-10"style={{border:"1px solid #E5F4F2",height:"fit-content", borderRadius:"20px", boxShadow: "34.8541px 29.626px 48.34px rgba(51, 102, 255, 0.05)"}}>
            
            <p className='text-lg text-gray-700  leading-relaxed text-justify mx-auto' style={{ textWrap: 'pretty' }}>
              <strong>1.</strong>{' '}
              <strong>Engagement and Strategic Involvement:</strong> Procreate a
              network of professional career counsellors in the country and
              nurture it through hatching opportunities for them to work
              together with schools, colleges, CSR Foundations, businesses, and
              professional bodies to meet changing career development needs
              among students, graduates, and professionals.
              <br />
              <br />
              <strong>2.</strong>{' '}
              <strong>Promotion of Professionalism and Standards:</strong> To
              provide a common platform to inculcate professionalism with
              respect to career counselling, sales, marketing and personal
              branding among career counsellors, including provision of
              training, certifications, adoption of ethical standards and
              professional ratings in career counselling.
              <br />
              <br />
              <strong>3.</strong> <strong>Advocacy and Representation:</strong>{' '}
              To act as the voice for career counsellors, promote supportive
              policies, working with government and international organisations.
              <br />
              <br />
              <strong>4.</strong>{' '}
              <strong>Public Awareness, Outreach and Skill Building:</strong> To
              build awareness about career counselling through events, campaigns
              using print, electronic and social media and contribute to the
              nation’s growth by offering skill-building programs aligned with
              the New Education Policy (NEP).
              <br />
              <br />
              <strong>5.</strong>{' '}
              <strong>
                Research, Knowledge Development, and Technological Integration:
              </strong>{' '}
              Facilitate research and create global knowledge resource in the
              form of digital tools and techniques, creative methods and
              strategies in professional career counselling.
              <br />
              <br />
              <strong>6.</strong>{' '}
              <strong>Accessibility, Inclusivity, and Recognition:</strong> Make
              career counselling accessible to all particularly children, youth
              and young professionals pan India ensuring their holistic
              development beyond academic achievements and recognise Career
              Counsellors for their contributions and achievements.
              <br />
              <br />
              <strong>7.</strong>{' '}
              <strong>Continuous Professional Support:</strong> Provide ongoing
              support, resources, and mentoring to career counsellors to help
              them stay updated about latest industry trends and improve their
              professional practice.
            </p>
          </div>

          {/* Animated Image */}
         <motion.div
           className="relative flex flex-col   rounded-lg overflow-hidden w-full "
           style={{ height: "96%", borderRadius:"20px" }}// Ensuring it takes full height of the text
         >
           <motion.img
             
             src={img}
             alt="APCCI Team 1"
             className="w-full object-cover h-1/2 rounded-lg mb-10"
           />
           <motion.img
            
             src={img2} // Replace with second image
             alt="APCCI Team 2"
             className="w-full object-cover h-1/2 rounded-lg"
           />
         </motion.div>
        </motion.div>

        {/* Call to Action Section */}
        <div className='cta-section  text-center py-16'>
          <motion.h3
            className='text-4xl font-bold mb-4'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8 }}
          >
            Ready to Make a Difference?
          </motion.h3>
          <p className='text-lg mb-8 max-w-2xl mx-auto'>
            Join the APCCI community and help shape the future of career
            counselling in India.
          </p>
          <motion.button
            whileHover={{ scale: 1.1 }}
            className='cta-button'
            onClick={handleContact}
          >
            Get Started Now
          </motion.button>
        </div>
      </motion.div>
      <Footer />
    </>
  )
}
export default Objectives;
